export function createReducer(getInitialState) {
  function reducer(state, action) {
    switch (action.type) {
      case 'END_EXPERIENCE':
        return {
          ...getInitialState(),
          ...action.data
        };
      case 'SHOW_MODAL':
        return {
          ...state,
          ...action.data
        };
      default:
        return state;
    }
  }
  return reducer;
}